import { useRef, useMemo, useCallback } from 'react';

const getLocalStorageValue = (key, initialValue) => {
  const item = window.localStorage.getItem(key);
  return item || initialValue;
};

const useLocalStorage = (key, initialValue) => {
  // State to store our value
  const storedValue = useRef(getLocalStorageValue(key, initialValue));

  // Update local storage when the state changes
  const setStoredValue = useCallback(
    value => {
      storedValue.current = value;
      window.localStorage.setItem(key, value);
    },
    [key],
  );

  const value = useMemo(() => {
    return [storedValue.current, setStoredValue];
  }, [setStoredValue]);

  return value;
};

export default useLocalStorage;
